import getCustomHeadersForNudgeRequest from './getCustomHeadersForNudgeRequest';
import { NudgeAction, UpdateNudgesRequest } from '../types/UpdateNudgesRequest';
import { FOCUSED_INBOX_REQUEST_BASE_URL } from '../utils/nudgeConstants';
import { getGuid } from 'owa-guid';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { makePostRequest } from 'owa-ows-gateway';
import { trace } from 'owa-trace';

const UPDATE_NUDGES_URL: string = FOCUSED_INBOX_REQUEST_BASE_URL + '/UpdateNudge';

export default async function updateNudgesOperation(
    itemId: string,
    nudgeAction: NudgeAction
): Promise<void> {
    const headers = await getCustomHeadersForNudgeRequest();
    const requestBody: UpdateNudgesRequest = {
        ItemId: { Id: itemId },
        NudgeAction: nudgeAction,
    };

    const updateNudgesResponse = await makePostRequest(
        UPDATE_NUDGES_URL,
        requestBody,
        getGuid() /* correlationId */,
        false /* returnFullResponse */,
        headers
    );

    try {
        if (!isSuccessStatusCode(updateNudgesResponse.status)) {
            trace.warn('updateNudgesOperation return http status ' + updateNudgesResponse.status);
        }
    } catch (error) {
        trace.info('updateNudgesOperation return error ' + error.message);
        return null;
    }
}
